/** Folds a flat, category-sorted list into consecutive runs grouped by `category`. */
export function groupResultsByCategory<T extends {category: string}>(
  results: readonly T[],
): {category: string; results: T[]}[] {
  const groups: {category: string; results: T[]}[] = [];
  for (const result of results) {
    const last = groups[groups.length - 1];
    if (last && last.category === result.category) {
      last.results.push(result);
    } else {
      groups.push({category: result.category, results: [result]});
    }
  }
  return groups;
}
